export default __webpack_public_path__ + "static/media/defendant-1-3.39dfeb51.jpg";